<template>
  <div>

    <!-- Photo preload from OPFS -->
    <div v-if="renderTemplatePhotos" v-show="false" v-for="photo in track.gpsTrack.photos" :key="photo.id">
      <span>{{ photo.get_image_fullhd() }}</span>
      <span>{{ photo.get_image_thumb() }}</span>
    </div>

    <span ref="gallerySpan"></span>

    <!-- videos -->
    <div style="z-index: 5000000;" ref="videoModal" class="modal fade" tabindex="-1" role="dialog">
      <info-modal :title="$t('trackVideos')">
        <div v-if="videoModalOpened">
          <div v-for="video in track.gpsTrack.videos" :key="video.id">
            <b>{{ video.name }}</b><br>
            <div v-if="video.description">{{ video.description }}<br></div>
            <br>
            <span style="text-align: center"><div v-html="video.html"></div><br><br></span>
          </div>
        </div>  
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="closeVideoModal">
            <strong>{{ $t('close') }}</strong>
          </button>
        </div>
      </info-modal>
    </div>

  </div>  
</template>

<script lang="ts">
import BaseComponent from '@/components/Base.vue';
import Track from '@/ts/Track';
import { EventBus } from '@/ts/EventBus';
import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import lgAutoplay from 'lightgallery/plugins/autoplay';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        return {
            renderTemplatePhotos: false,
            videoModalOpened: false
        };
    },
    mounted() {
        EventBus.$on('openTrackGallery' + this.track.gpsTrack.id, (index: number) => this.makeGallery(false, index));
        EventBus.$on('openTrackGalleryMaxRes' + this.track.gpsTrack.id, (index: number) => this.makeGallery(true, index));
        EventBus.$on('openTrackVideoModal' + this.track.gpsTrack.id, this.clickOpenVideos);
    },
    methods: {
        clickOpenVideos() {
            this.videoModalOpened = true;
            this.openModal(this.$refs.videoModal);
        },
        closeVideoModal() {
            this.videoModalOpened = false;
            this.closeModal(this.$refs.videoModal);
        },
        waitForElementsReadyAndOpenGallery(maxRes: boolean, index: number) {
            let allElementsReady = true;
            for(const photo of this.track.gpsTrack.photos) {
              if ((! photo.get_image_thumb()) || (! photo.get_image_fullhd)) {
                allElementsReady = false;
              }
            }
            if (allElementsReady) {
              const photos: Array<{src: string, thumb: string}> = [];
              for (const photo of this.track.gpsTrack.photos) {
                let photoToAdd = null;
                if (maxRes) {
                  photoToAdd = {src: photo.image, thumb: photo.get_image_thumb()};
                } else {
                  photoToAdd = {src: photo.get_image_fullhd(), thumb: photo.get_image_thumb()};
                }
                photos.push(photoToAdd)
              }
              const gallery = lightGallery(this.$refs.gallerySpan, {
                dynamic: true,
                dynamicEl: photos,
                plugins: [lgZoom, lgAutoplay],
                showZoomInOutIcons: true,
                slideShowInterval: 3000,
                index: index,
                allowMediaOverlap: true,
                mobileSettings: {
                  controls: false, 
                  showCloseIcon: true, 
                  download: false
                },
              });
              gallery.openGallery();
            } else {
              setTimeout(() => this.waitForElementsReadyAndOpenGallery(maxRes, index), 10);
            }
        },
        makeGallery(maxRes: boolean, index: number) {
            this.renderTemplatePhotos = true;
            this.waitForElementsReadyAndOpenGallery(maxRes, index);
        }
    },
    props: {
        track: { required: true, type: Object as PropType<Track>}
    }
})

</script>